<div class="overlay"  [class.visible]="isAutoscoreSidebarOpen" (click)="closeAutoscoreSidebar()" ></div>
<div 
  class="autoscore-sidebar" *ngIf="isAutoscoreSidebarOpen" >
  
  <div class="header">
    <div class="back-and-header">
      <i (click)="closeAutoscoreSidebar()">keyboard_backspace</i>
      <span class="title">My Autoscore</span>
    </div>
    <i class="share-icon" (click)="onShare()">share</i>
  </div>
  <div class="points-date">
    <mat-icon></mat-icon>
    <img src="../../../../assets/images/autoscore_img.svg">
    <span class="points"> {{ score }} pt</span>
    <span class="date">{{ updatedDate | date: 'dd MMM yyyy' }}</span>
  </div>

<div class="gauge-wrapper">

  <svg viewBox="0 0 200 200" class="gauge">
  <!-- Colored Arcs -->
  <ng-container *ngFor="let band of bands">
    <path
      [attr.d]="getArcPath(band.start, band.end, 90)"
      [attr.stroke]="band.color"
      stroke-width="10"
      fill="none"
    />
  </ng-container>

  <g>
    <rect x="20" y="170" width="30" height="18" rx="4" ry="4" fill="#FF4D4F" />
    <text x="35" y="183" text-anchor="middle" font-size="10" fill="#fff">00</text>
  </g>

  <g>
    <rect x="150" y="170" width="40" height="18" rx="4" ry="4" fill="#52C41A" />
    <text x="170" y="183" text-anchor="middle" font-size="10" fill="#fff">1000</text>
  </g>


  <!-- Needle and center circles as you already have -->
 <!-- Rotating Needle Group -->
<g [attr.transform]="'rotate(' + needleRotation + ', 100, 100)'">
  <line
    x1="100"
    y1="100"
    x2="100"
    y2="10"
    stroke="#000"
    stroke-width="2"
  />
</g>

<!-- Fixed Center Circles -->
<circle cx="100" cy="100" r="14" fill="#2196F3" />
<circle cx="100" cy="100" r="8" fill="#000000" />
<circle cx="100" cy="100" r="22" fill="#B3E5FC" opacity="0.3" />

</svg>


  <!-- Center Score and Grade -->
  <div class="center-score">
  <div class="score">{{ score }}</div>
  <div class="grade">{{ scale }} {{ getGradeText(scale) }}</div>
</div>

</div>

<div class="description">
  {{ description ? description : 'No description available.' }}
</div>
<div class="legend">
  <div class="legend-item dot-poor">
    <span class="dot"></span>
    <div class="grade-label"><strong>F</strong></div>
    <span class="label"><strong>Poor</strong></span>
    <span class="range">000 - 499</span>
  </div>
  <div class="legend-item dot-fair">
    <span class="dot"></span>
    <div class="grade-label"><strong>D</strong></div>
    <span class="label"><strong>Fair</strong></span>
    <span class="range">500 - 599</span>
  </div>
  <div class="legend-item dot-good">
    <span class="dot"></span>
    <div class="grade-label"><strong>A</strong></div>
    <span class="label"><strong>Good</strong></span>
    <span class="range">600 - 699</span>
  </div>
  <div class="legend-item dot-super">
    <span class="dot"></span>
    <div class="grade-label"><strong>AA</strong></div>
    <span class="label"><strong>Super</strong></span>
    <span class="range">700 - 799</span>
  </div>
  <div class="legend-item dot-excellent">
    <span class="dot"></span>
    <div class="grade-label"><strong>AAA</strong></div>
    <span class="label"><strong>Excellent</strong></span>
    <span class="range">800 - 1000</span>
  </div>
</div>
</div>
